<template>
  <div class="photo-cell col-6 col-md-6 col-lg-3" :style="{height:photoCellHeight +'px'}" ref="photoCell">
    <div class="photo-cell-inner h-100 p-1 relative-position" :class="{ favorite: input.isBuyTarget }">
      <div class="d-flex flex-column h-100">
        <div class="photo-no text-center clearfix pl-3">
          <!--<div class="purchased-label"><trans-text i18nKey="ui['7'][1]" /></div>-->
          <div>{{photo.photo_no}}</div>
        </div>
        <div class="flex-grow-1" :style="{height:photoImageWrapHeight +'px'}" ref="photoImageWrap">
          <div class="photo-image contain" v-lazy:background-image="smallThumbnailUrl" @click="showPhotoImageModal"></div>
        </div>
        <div class="row no-gutters cart-photo-operation align-items-center">
          <div class="pl-5 col-auto text-center">
            <span class="size-info d-inline-block py-1 px-1">{{photoSizeMark}}</span>
          </div>
          <div class="price-info col text-center">
            <trans-text i18nKey="ui['91'][3]"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {dd,store,app} from 'systems/imports'
  import Cart from 'processor/Cart'

  export default {
    name:"",
    props:["cartPhoto","cart"],

    components: {
    },
    data () {
      return {
        input:{
          isBuyTarget:false,
        },
        photoCellHeight:null,
        photoImageWrapHeight:null

      }
    },
    watch:{
      "$root.lastAtAdjustLayout"(){
        this.$nextTick()
          .then(()=>{
            this._adjustPhotoCellHeight()
            this.photoImageWrapHeight = 0
            return this.$nextTick()
          }).then(()=>{
          this._adjustphotoImageWrapHeight()
        })
      },
      "cartPhoto"(){
          if(!this.cartPhoto){return false }
          this.input.isBuyTarget = this.cartPhoto.is_purchase_target
      },
      "input.isBuyTarget"(){
        this.$emit("changeCartPhotoPurchaseTarget",this.cartPhoto,this.input.isBuyTarget)
      },
    },
    mounted(){
      this.$nextTick(()=>{
        this._adjustPhotoCellHeight()
        this.$nextTick(()=>{
          this._adjustphotoImageWrapHeight()
        })
      })
      if(this.cartPhoto){
        this.input.isBuyTarget = this.cartPhoto.is_purchase_target
      }
    },
    computed:{
      photo(){
        return this.cartPhoto.photo || {}
      },
      photoSizeMark(){
        let cartPhoto = this.cartPhoto
        if(!cartPhoto){ return "M" }
        if(!cartPhoto.photo_sizes){ return "M" }
        let photoSize = app.make("_").first(cartPhoto.photo_sizes)
        if(!photoSize){
          return "M"
        }
        switch(Number(photoSize.id)){
          case 1:
              return "M"
          case 2:
              return "L"
        }
      },
      isFavorited(){
          return !app.make("_").isEmpty(this.photo.cart_photos);
      },
      smallThumbnailUrl(){
        let photo = this.photo
        if(!photo){ return null }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === "1")
        })
        return photoThumbnail.image_url + '?token='+store.get("token")
      },
    },
    methods:{
      toggleCartPhotoSizePopoverForm(){
        this.$emit("toggleCartPhotoSizePopoverForm",this.cartPhoto)
      },
      //
      _adjustPhotoCellHeight(){
        this.photoCellHeight = $(this.$refs.photoCell).width()
      },
      _adjustphotoImageWrapHeight(){
        this.photoImageWrapHeight = $(this.$refs.photoImageWrap).height()
      },

      //
      showPhotoImageModal(){
        this.$emit("showPhotoImageModal",this.photo)
      },
      addCart(){
        this.$emit("addCarPhoto",this.photo)
      },
      removeCartPhoto(){
        this.$emit("removeCartPhoto",this.cartPhoto)
      }

    }
  }
</script>

<style lang="scss" scoped>

  .custom-control-indicator{
    top:0;
    border:2px solid #a8a5a3;
    background-color: #fff;
  }

  .purchase-target-check{
    position: absolute;
    right: 22px;
    top: -2px;
    z-index: 100;
    span,input{
      width: 1.5rem;
      height:1.5rem;
    }
  }
  .custom-control-input:checked ~ .custom-control-indicator{
    /*background-color: #fff;*/
    /*color: #ec4828;*/
  }

  .purchased-label{
    font-size: 0.6rem;
    position: absolute;
    left:0;
    padding: 0 1px;
    color: #82ba1d;
    border: #82ba1d solid 1px;
  }


  .photo-cell{
    margin-bottom:2px;

    .photo-cell-inner {
      background-color: #fff;
      border: 2px solid #a8a5a3;
      border-radius: .5rem;

      &.favorite{
        border:2px solid #ec5c45;
      }
      .photo-no{
        position: relative;
        font-size: 0.8rem;
      }
      .photo-image{

      }

      .cart-photo-operation{

        @mixin cart-photo-operation-btn-style {
          font-size:10px;
          padding:2px;
          margin:0;
          width:100%;
        }
        .favorite-operation{
          @include cart-photo-operation-btn-style;
        }
        .size-info{
          @include cart-photo-operation-btn-style;
          font-weight: bold;
          border: 1px #f79a1d solid;
          line-height: 1.25;
          vertical-align: middle;
          color:#f79a1d;
        }
        .size-operation{
          @include cart-photo-operation-btn-style;
        }
      }

      .image-zoom-btn{
        color: #82ba1d;
        cursor: pointer;
        position: absolute;
        right:5px;
        top :50%;
        transform: translateY(-50%) translateX(0);
      }
    }
  }

  .price-info{
    font-size:.9rem;
  }

</style>



// WEBPACK FOOTER //
// SnapHorizonPhoto.vue?2d821876